import React from "react";
import {HistoryLoadingIcon} from "@resource";

function ElementLoading() {
    return (
        <div className="elementLoading"><HistoryLoadingIcon /></div>
    )
}

export default ElementLoading